import React, { useEffect, useState } from "react";
import Footer from "../components/Footer.js";
import Navbar from "../components/Navbar.js";
// img
import w1 from "../assets/images/w1.svg";
import Navbarinner from "../components/Navbarinner.js";

import { getCMSPage } from "../action/user.action.js";
import { getLang } from "../lib/localStorage.js";
// Scroll to Top
function ScrollToTopOnMount() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return null;
}

export default function Privacy() {
const [content, setContent] = useState("");
    let langCode = getLang();

    // function
    const fetchCmsPage = async () => {
        try {
            const { status, loading, result } = await getCMSPage({
                identifier: "privacy_policy",
                langCode,
            });
            if (status == "success") {
                // console.log('result', result)
                setContent(result);
                document.title = result.title;
                const el = document.querySelector(
                    "meta[name='metadescription']"
                );
                el.setAttribute("content", result.metadescription);

                const els = document.querySelector("meta[name='keywords']");
                els.setAttribute("content", result.metakeywords);
            }
        } catch (err) {}
    };

    useEffect(() => {
        fetchCmsPage();
    }, []);

    console.log(content, "contentcontent");

  return (
    <div>
      <Navbar />
      <div className="common_page" >
     <div className="container" >
     <div dangerouslySetInnerHTML={{ __html: content.content }} />
     </div>
      </div>
      <Footer />
    </div>
  );
}
